<template>
  <span
    class="owal expanding input"
  >
    <input
      ref="input"
      :placeholder="placeholder"
      :style="{width: this.width}"
      type="text"
      autocomplete="off"
      :value="initialValue"
      @blur="handleBlur"
      @input="input"
      @keyup.delete="handleDelete"
    >
    <span
      ref="backingStore"
      class="backingStore"
    />
  </span>
</template>

<script>
import { Input } from './mixins'

export default {
  name: 'OwalAutosizingInput',
  mixins: [Input],
  props: {
    initialValue: {
      type: String,
      required: false,
      default: undefined,
    },
    placeholder: {
      type: String,
      required: false,
      default: undefined,
    },
  },
  data () {
    return {
      width: '60px',
      minimumWidth: 60,
    }
  },
  mounted () {
    this.updateBackingStore()
    this.focus()
  },
  methods: {
    input: function (value) {
      this.updateBackingStore()

      this.$emit('input', event.target.value)
    },
    updateBackingStore: function () {
      if (!this.$refs) {
        return
      }

      const backingStore = this.$refs['backingStore']
      const input = this.$refs['input']

      let value = input.value ? input.value : input.placeholder

      if (backingStore.textContent) {
        backingStore.textContent = value
      } else {
        backingStore.innerText = value
      }
      backingStore.style.display = 'inline'
      const width = Math.max(backingStore.scrollWidth, backingStore.offsetWidth, backingStore.clientWidth)
      backingStore.style.display = 'none'

      this.width = Math.max(width, this.minimumWidth) + 'px'
    },
    handleDelete (e) {
      this.$emit('delete-pressed')
    },
    handleBlur () {
      this.$emit('blur')
    },
    focus () {
      const el = this.$refs.input
      el.focus()
    },
  },
}
</script>

<style scoped>
  .owal.expanding.input {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .owal.expanding.input input[type='text']
  {
    border: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    min-width: 10px;
  }
  .owal.expanding.input .backingStore
  {
    display: none;
    white-space: pre;
    margin:0;
    padding:0;
    border: 1px solid rgba(34, 36, 28, 0.14902);
  }
  .owal.expanding.input input,
  .owal.expanding.input .backingStore
  {
    font: inherit;
    white-space: pre;
    margin:0;
    padding:0;
  }
</style>
